var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-view"},[_c('ul',[(!_vm.isEmpty)?_c('tree-node',{attrs:{"node":_vm.model,"selection":_vm.selection,"expanded":true,"label":_vm.label,"track-by":_vm.trackBy,"children-prop":_vm.childrenProp},on:{"update:selection":_vm.onUpdateSelection}},[_c('template',{slot:"iconFolder"},[_vm._t("iconFolder")],2)],2):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }